/* eslint-disable */
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppServiceWebapp = void 0;
var http_1 = require("@wix/ambassador/runtime/http");
var AppServiceWebapp = function (baseUrl, httpClientConfig) {
    var httpClient = new http_1.AmbassadorHTTPClient(baseUrl, httpClientConfig);
    return {
        Apps: function () {
            return function (headers) {
                var service = {
                    archiveApp: function (archiveAppRequest) { return httpClient.invoke('PUT', '/v1/apps/{app_id}/archive', archiveAppRequest, headers); },
                    bulkDeleteAutomationApps: function (bulkDeleteAutomationAppsRequest) {
                        return httpClient.invoke('POST', '/v1/apps/bulk-delete-automation', bulkDeleteAutomationAppsRequest, headers);
                    },
                    create: function (createAppRequest) { return httpClient.invoke('POST', '/v1/apps', createAppRequest, headers); },
                    deleteApp: function (deleteAppRequest) { return httpClient.invoke('PUT', '/v1/apps/{app_id}/delete', deleteAppRequest, headers); },
                    getAllAppsByProperty: function (getAllAppsByPropertyRequest) {
                        return httpClient.invoke('GET', '/v1/apps/get-all-apps-by-property', getAllAppsByPropertyRequest, headers);
                    },
                    getAppByVersion: function (getAppByVersionRequest) {
                        return httpClient.invoke('GET', '/v1/apps/{app_id}/version/{version}', getAppByVersionRequest, headers);
                    },
                    getApps: function (getAppsRequest) { return httpClient.invoke('GET', '/v1/allapps', getAppsRequest, headers); },
                    getAppsByAppName: function (getAppsByAppNameRequest) {
                        return httpClient.invoke('GET', '/v1/apps/app-name', getAppsByAppNameRequest, headers);
                    },
                    getAppsByEmail: function (getAppsByEmailRequest) {
                        return httpClient.invoke('GET', '/v1/apps/user-email/{email}', getAppsByEmailRequest, headers);
                    },
                    getAppSecret: function (getAppSecretRequest) {
                        return httpClient.invoke('GET', '/v1/apps/{app_id}/secret', getAppSecretRequest, headers);
                    },
                    getAppServerAuth: function (getAppServerAuthRequest) {
                        return httpClient.invoke('GET', '/v1/apps/{app_id}/server-auth', getAppServerAuthRequest, headers);
                    },
                    getAppsInfo: function (getAppsInfoRequest) { return httpClient.invoke('GET', '/v1/apps-info', getAppsInfoRequest, headers); },
                    getAppSnapshot: function (getAppRequest) { return httpClient.invoke('GET', '/v1/apps/{app_id}', getAppRequest, headers); },
                    getDeveloperApps: function (getDeveloperAppsRequest) {
                        return httpClient.invoke('GET', '/v1/apps', getDeveloperAppsRequest, headers);
                    },
                    setAppNamespace: function (setAppNamespaceRequest) {
                        return httpClient.invoke('POST', '/api/v1/apps/set-app-namespace', setAppNamespaceRequest, headers);
                    },
                    updateAppJson: function (updateAppJsonRequest) {
                        return httpClient.invoke('POST', '/v1/apps/{app_id}/update-json', updateAppJsonRequest, headers);
                    },
                    updateAppProperty: function (updateAppPropertyRequest) {
                        return httpClient.invoke('POST', '/v1/apps/{app_id}/update-app-property', updateAppPropertyRequest, headers);
                    },
                    updateWixApp: function (updateWixAppRequest) {
                        return httpClient.invoke('POST', '/v1/apps/{app_id}/wix-app', updateWixAppRequest, headers);
                    },
                };
                service.archiveApp.__http_method = 'PUT';
                service.archiveApp.__http_url = '/v1/apps/{app_id}/archive';
                service.bulkDeleteAutomationApps.__http_method = 'POST';
                service.bulkDeleteAutomationApps.__http_url = '/v1/apps/bulk-delete-automation';
                service.create.__http_method = 'POST';
                service.create.__http_url = '/v1/apps';
                service.deleteApp.__http_method = 'PUT';
                service.deleteApp.__http_url = '/v1/apps/{app_id}/delete';
                service.getAllAppsByProperty.__http_method = 'GET';
                service.getAllAppsByProperty.__http_url = '/v1/apps/get-all-apps-by-property';
                service.getAppByVersion.__http_method = 'GET';
                service.getAppByVersion.__http_url = '/v1/apps/{app_id}/version/{version}';
                service.getApps.__http_method = 'GET';
                service.getApps.__http_url = '/v1/allapps';
                service.getAppsByAppName.__http_method = 'GET';
                service.getAppsByAppName.__http_url = '/v1/apps/app-name';
                service.getAppsByEmail.__http_method = 'GET';
                service.getAppsByEmail.__http_url = '/v1/apps/user-email/{email}';
                service.getAppSecret.__http_method = 'GET';
                service.getAppSecret.__http_url = '/v1/apps/{app_id}/secret';
                service.getAppServerAuth.__http_method = 'GET';
                service.getAppServerAuth.__http_url = '/v1/apps/{app_id}/server-auth';
                service.getAppsInfo.__http_method = 'GET';
                service.getAppsInfo.__http_url = '/v1/apps-info';
                service.getAppSnapshot.__http_method = 'GET';
                service.getAppSnapshot.__http_url = '/v1/apps/{app_id}';
                service.getDeveloperApps.__http_method = 'GET';
                service.getDeveloperApps.__http_url = '/v1/apps';
                service.setAppNamespace.__http_method = 'POST';
                service.setAppNamespace.__http_url = '/api/v1/apps/set-app-namespace';
                service.updateAppJson.__http_method = 'POST';
                service.updateAppJson.__http_url = '/v1/apps/{app_id}/update-json';
                service.updateAppProperty.__http_method = 'POST';
                service.updateAppProperty.__http_url = '/v1/apps/{app_id}/update-app-property';
                service.updateWixApp.__http_method = 'POST';
                service.updateWixApp.__http_url = '/v1/apps/{app_id}/wix-app';
                return service;
            };
        },
        AppsV2: function () {
            return function (headers) {
                var service = {
                    appsByComponentType: function (appsByComponentTypeRequest) {
                        return httpClient.invoke('POST', 'v2/apps/apps-by-component-type', appsByComponentTypeRequest, headers);
                    },
                    query: function (queryAppsRequest) { return httpClient.invoke('POST', 'v2/apps/query', queryAppsRequest, headers); },
                };
                service.appsByComponentType.__http_method = 'POST';
                service.appsByComponentType.__http_url = 'v2/apps/apps-by-component-type';
                service.query.__http_method = 'POST';
                service.query.__http_url = 'v2/apps/query';
                return service;
            };
        },
        Categories: function () {
            return function (headers) {
                var service = {
                    getCategory: function (getCategoryRequest) {
                        return httpClient.invoke('GET', 'api/v1/categories/{category_id}', getCategoryRequest, headers);
                    },
                    getMainCategories: function (getMainCategoriesRequest) {
                        return httpClient.invoke('GET', 'api/v1/categories', getMainCategoriesRequest, headers);
                    },
                    getSubCategories: function (getSubCategoriesRequest) {
                        return httpClient.invoke('GET', 'api/v1/categories/{category_id}/sub-categories', getSubCategoriesRequest, headers);
                    },
                };
                service.getCategory.__http_method = 'GET';
                service.getCategory.__http_url = 'api/v1/categories/{category_id}';
                service.getMainCategories.__http_method = 'GET';
                service.getMainCategories.__http_url = 'api/v1/categories';
                service.getSubCategories.__http_method = 'GET';
                service.getSubCategories.__http_url = 'api/v1/categories/{category_id}/sub-categories';
                return service;
            };
        },
        Components: function () {
            return function (headers) {
                var service = {
                    create: function (createComponentRequest) {
                        return httpClient.invoke('POST', '/v1/apps/{app_id}/components', createComponentRequest, headers);
                    },
                    delete: function (deleteComponentRequest) {
                        return httpClient.invoke('DELETE', '/v1/apps/{app_id}/components/{comp_id}', deleteComponentRequest, headers);
                    },
                    update: function (updateComponentRequest) {
                        return httpClient.invoke('PUT', '/v1/apps/{app_id}/components/{comp_id}', updateComponentRequest, headers);
                    },
                    updateComponents: function (updateComponentsRequest) {
                        return httpClient.invoke('PUT', '/v1/apps/{app_id}/components/bulk', updateComponentsRequest, headers);
                    },
                };
                service.create.__http_method = 'POST';
                service.create.__http_url = '/v1/apps/{app_id}/components';
                service.delete.__http_method = 'DELETE';
                service.delete.__http_url = '/v1/apps/{app_id}/components/{comp_id}';
                service.update.__http_method = 'PUT';
                service.update.__http_url = '/v1/apps/{app_id}/components/{comp_id}';
                service.updateComponents.__http_method = 'PUT';
                service.updateComponents.__http_url = '/v1/apps/{app_id}/components/bulk';
                return service;
            };
        },
        ComponentsCatalog: function () {
            return function (headers) {
                var service = {
                    createComponentCatalog: function (createComponentCatalogRequest) {
                        return httpClient.invoke('POST', 'api/v1/components-catalog/create', createComponentCatalogRequest, headers);
                    },
                    deleteComponentCatalog: function (deleteComponentCatalogRequest) {
                        return httpClient.invoke('DELETE', 'api/v1/components-catalog/delete', deleteComponentCatalogRequest, headers);
                    },
                    getComponentsCatalog: function (any) { return httpClient.invoke('GET', 'api/v1/components-catalog', any, headers); },
                    updateComponentCatalog: function (updateComponentCatalogRequest) {
                        return httpClient.invoke('POST', 'api/v1/components-catalog/update', updateComponentCatalogRequest, headers);
                    },
                };
                service.createComponentCatalog.__http_method = 'POST';
                service.createComponentCatalog.__http_url = 'api/v1/components-catalog/create';
                service.deleteComponentCatalog.__http_method = 'DELETE';
                service.deleteComponentCatalog.__http_url = 'api/v1/components-catalog/delete';
                service.getComponentsCatalog.__http_method = 'GET';
                service.getComponentsCatalog.__http_url = 'api/v1/components-catalog';
                service.updateComponentCatalog.__http_method = 'POST';
                service.updateComponentCatalog.__http_url = 'api/v1/components-catalog/update';
                return service;
            };
        },
        Dependencies: function () {
            return function (headers) {
                var service = {
                    addDependencies: function (addDependenciesRequest) {
                        return httpClient.invoke('POST', 'api/v1/apps/dependencies', addDependenciesRequest, headers);
                    },
                    deleteDependencies: function (deleteDependenciesRequest) {
                        return httpClient.invoke('DELETE', 'api/v1/apps/dependencies', deleteDependenciesRequest, headers);
                    },
                    getDependencies: function (getDependenciesRequest) {
                        return httpClient.invoke('GET', 'api/v1/apps/dependencies/{app_id}', getDependenciesRequest, headers);
                    },
                    resolveDependencies: function (resolveDependenciesRequest) {
                        return httpClient.invoke('GET', 'api/v1/apps/resolve-dependencies', resolveDependenciesRequest, headers);
                    },
                    resolveDependenciesByVersion: function (resolveDependenciesByVersionRequest) {
                        return httpClient.invoke('POST', 'api/v1/apps/resolve-dependencies-by-version', resolveDependenciesByVersionRequest, headers);
                    },
                    updateDependencies: function (updateDependenciesRequest) {
                        return httpClient.invoke('PUT', 'api/v1/apps/dependencies', updateDependenciesRequest, headers);
                    },
                };
                service.addDependencies.__http_method = 'POST';
                service.addDependencies.__http_url = 'api/v1/apps/dependencies';
                service.deleteDependencies.__http_method = 'DELETE';
                service.deleteDependencies.__http_url = 'api/v1/apps/dependencies';
                service.getDependencies.__http_method = 'GET';
                service.getDependencies.__http_url = 'api/v1/apps/dependencies/{app_id}';
                service.resolveDependencies.__http_method = 'GET';
                service.resolveDependencies.__http_url = 'api/v1/apps/resolve-dependencies';
                service.resolveDependenciesByVersion.__http_method = 'POST';
                service.resolveDependenciesByVersion.__http_url = 'api/v1/apps/resolve-dependencies-by-version';
                service.updateDependencies.__http_method = 'PUT';
                service.updateDependencies.__http_url = 'api/v1/apps/dependencies';
                return service;
            };
        },
        Extensions: function () {
            return function (headers) {
                var service = {
                    createExtension: function (createExtensionRequest) {
                        return httpClient.invoke('POST', 'api/v1/extensions/create', createExtensionRequest, headers);
                    },
                    getExtenders: function (getExtendersRequest) {
                        return httpClient.invoke('GET', 'api/v1/extensions/{extension_type}/get-extenders', getExtendersRequest, headers);
                    },
                    getExtensions: function (getExtensionsRequest) {
                        return httpClient.invoke('GET', 'api/v1/extensions/get', getExtensionsRequest, headers);
                    },
                    updateExtension: function (updateExtensionRequest) {
                        return httpClient.invoke('POST', 'api/v1/extensions/update', updateExtensionRequest, headers);
                    },
                };
                service.createExtension.__http_method = 'POST';
                service.createExtension.__http_url = 'api/v1/extensions/create';
                service.getExtenders.__http_method = 'GET';
                service.getExtenders.__http_url = 'api/v1/extensions/{extension_type}/get-extenders';
                service.getExtensions.__http_method = 'GET';
                service.getExtensions.__http_url = 'api/v1/extensions/get';
                service.updateExtension.__http_method = 'POST';
                service.updateExtension.__http_url = 'api/v1/extensions/update';
                return service;
            };
        },
        ExternalTranslations: function () {
            return function (headers) {
                var service = {
                    syncTranslationResources: function (syncTranslationResourcesRequest) {
                        return httpClient.invoke('POST', 'api/v1/apps/{app_id}/localization/sync', syncTranslationResourcesRequest, headers);
                    },
                    syncTranslationResources2: function (syncTranslationResourcesRequest) {
                        return httpClient.invoke('POST', 'api/v1/app/{app_id}/localization/sync', syncTranslationResourcesRequest, headers);
                    },
                };
                service.syncTranslationResources.__http_method = 'POST';
                service.syncTranslationResources.__http_url = 'api/v1/apps/{app_id}/localization/sync';
                service.syncTranslationResources2.__http_method = 'POST';
                service.syncTranslationResources2.__http_url = 'api/v1/app/{app_id}/localization/sync';
                return service;
            };
        },
        ListingInfo: function () {
            return function (headers) {
                var service = {
                    get: function (getListingInfoRequest) {
                        return httpClient.invoke('GET', 'api/v1/apps/{app_id}/listing-info', getListingInfoRequest, headers);
                    },
                    update: function (updateListingInfoRequest) {
                        return httpClient.invoke('PATCH', 'api/v1/apps/{app_id}/listing-info', updateListingInfoRequest, headers);
                    },
                };
                service.get.__http_method = 'GET';
                service.get.__http_url = 'api/v1/apps/{app_id}/listing-info';
                service.update.__http_method = 'PATCH';
                service.update.__http_url = 'api/v1/apps/{app_id}/listing-info';
                return service;
            };
        },
        ListingInfoV2: function () {
            return function (headers) {
                var service = {
                    addAsset: function (addAssetRequest) { return httpClient.invoke('PATCH', 'api/v2/apps/{app_id}/add-asset', addAssetRequest, headers); },
                    get: function (getListingInfo) { return httpClient.invoke('GET', 'api/v2/apps/{app_id}/listing-info', getListingInfo, headers); },
                    insertAssetsToMap: function (insertAssetsToMapRequest) {
                        return httpClient.invoke('PATCH', 'api/v2/apps/{app_id}/insert-assets', insertAssetsToMapRequest, headers);
                    },
                    upsert: function (updateListingInfo) { return httpClient.invoke('PATCH', 'api/v2/apps/{app_id}/listing-info', updateListingInfo, headers); },
                };
                service.addAsset.__http_method = 'PATCH';
                service.addAsset.__http_url = 'api/v2/apps/{app_id}/add-asset';
                service.get.__http_method = 'GET';
                service.get.__http_url = 'api/v2/apps/{app_id}/listing-info';
                service.insertAssetsToMap.__http_method = 'PATCH';
                service.insertAssetsToMap.__http_url = 'api/v2/apps/{app_id}/insert-assets';
                service.upsert.__http_method = 'PATCH';
                service.upsert.__http_url = 'api/v2/apps/{app_id}/listing-info';
                return service;
            };
        },
        Migration: function () {
            return function (headers) {
                var service = {
                    compareMigratedApp: function (compareMigratedAppRequest) {
                        return httpClient.invoke('POST', 'api/v1/apps/migration/compare', compareMigratedAppRequest, headers);
                    },
                    createAppForMigration: function (createAppForMigrationRequest) {
                        return httpClient.invoke('POST', 'api/v1/apps/migration/clone', createAppForMigrationRequest, headers);
                    },
                    fixOldClone: function (fixOldCloneRequest) {
                        return httpClient.invoke('POST', 'api/v1/apps/migration/fix-old-clone', fixOldCloneRequest, headers);
                    },
                    migrate: function (migrateRequest) { return httpClient.invoke('POST', 'api/v1/apps/migration/migrate', migrateRequest, headers); },
                    migrateApp: function (migrateAppEvent) { return httpClient.invoke('POST', 'api/cms/app', migrateAppEvent, headers); },
                    overrideAppId: function (overrideAppIdRequest) {
                        return httpClient.invoke('PUT', 'api/v1/apps/migration/change-app-id', overrideAppIdRequest, headers);
                    },
                };
                service.compareMigratedApp.__http_method = 'POST';
                service.compareMigratedApp.__http_url = 'api/v1/apps/migration/compare';
                service.createAppForMigration.__http_method = 'POST';
                service.createAppForMigration.__http_url = 'api/v1/apps/migration/clone';
                service.fixOldClone.__http_method = 'POST';
                service.fixOldClone.__http_url = 'api/v1/apps/migration/fix-old-clone';
                service.migrate.__http_method = 'POST';
                service.migrate.__http_url = 'api/v1/apps/migration/migrate';
                service.migrateApp.__http_method = 'POST';
                service.migrateApp.__http_url = 'api/cms/app';
                service.overrideAppId.__http_method = 'PUT';
                service.overrideAppId.__http_url = 'api/v1/apps/migration/change-app-id';
                return service;
            };
        },
        NameSpace: function () {
            return function (headers) {
                var service = {
                    create: function (createNameSpaceRequest) {
                        return httpClient.invoke('POST', 'api/v1/{app_id}/create-namespace', createNameSpaceRequest, headers);
                    },
                    get: function (getNameSpaceRequest) { return httpClient.invoke('GET', 'api/v1/{app_id}/namespace', getNameSpaceRequest, headers); },
                    getNameSpace: function (getNameSpaceRequest) {
                        return httpClient.invoke('GET', 'api/v2/{app_id}/namespace', getNameSpaceRequest, headers);
                    },
                    getSuggestion: function (getNameSpaceSuggestionRequest) {
                        return httpClient.invoke('GET', 'api/v1/{app_id}/namespace-suggestion', getNameSpaceSuggestionRequest, headers);
                    },
                };
                service.create.__http_method = 'POST';
                service.create.__http_url = 'api/v1/{app_id}/create-namespace';
                service.get.__http_method = 'GET';
                service.get.__http_url = 'api/v1/{app_id}/namespace';
                service.getNameSpace.__http_method = 'GET';
                service.getNameSpace.__http_url = 'api/v2/{app_id}/namespace';
                service.getSuggestion.__http_method = 'GET';
                service.getSuggestion.__http_url = 'api/v1/{app_id}/namespace-suggestion';
                return service;
            };
        },
        Permissions: function () {
            return function (headers) {
                var service = {
                    addOrUpdateAppUri: function (addOrUpdateAppUriRequest) {
                        return httpClient.invoke('POST', 'api/v1/apps/{app_id}/permissions/app-uri', addOrUpdateAppUriRequest, headers);
                    },
                    delete: function (deletePermissionRequest) {
                        return httpClient.invoke('DELETE', 'api/v1/apps/{app_id}/permissions/{permission_id}', deletePermissionRequest, headers);
                    },
                    deleteAppUri: function (deleteAppUriRequest) {
                        return httpClient.invoke('DELETE', 'api/v1/apps/{app_id}/permissions/app-uri', deleteAppUriRequest, headers);
                    },
                    getPermissions: function (getPermissionsRequest) {
                        return httpClient.invoke('GET', 'api/v1/apps/{app_id}/permissions', getPermissionsRequest, headers);
                    },
                    register: function (registerForPermissionRequest) {
                        return httpClient.invoke('POST', 'api/v1/apps/{app_id}/permissions', registerForPermissionRequest, headers);
                    },
                    updateAuth: function (updateAuthRequest) {
                        return httpClient.invoke('POST', 'api/v1/apps/{app_id}/permissions/auth-data', updateAuthRequest, headers);
                    },
                    updateRedirectUris: function (updateRedirectUrisRequest) {
                        return httpClient.invoke('PUT', 'api/v1/apps/{app_id}/permissions/redirect-uri', updateRedirectUrisRequest, headers);
                    },
                    upsertToAppPermissionsStore: function (upsertToAppPermissionsStoreRequest) {
                        return httpClient.invoke('POST', 'api/v1/apps/{app_id}/permissions/upsert-to-store', upsertToAppPermissionsStoreRequest, headers);
                    },
                };
                service.addOrUpdateAppUri.__http_method = 'POST';
                service.addOrUpdateAppUri.__http_url = 'api/v1/apps/{app_id}/permissions/app-uri';
                service.delete.__http_method = 'DELETE';
                service.delete.__http_url = 'api/v1/apps/{app_id}/permissions/{permission_id}';
                service.deleteAppUri.__http_method = 'DELETE';
                service.deleteAppUri.__http_url = 'api/v1/apps/{app_id}/permissions/app-uri';
                service.getPermissions.__http_method = 'GET';
                service.getPermissions.__http_url = 'api/v1/apps/{app_id}/permissions';
                service.register.__http_method = 'POST';
                service.register.__http_url = 'api/v1/apps/{app_id}/permissions';
                service.updateAuth.__http_method = 'POST';
                service.updateAuth.__http_url = 'api/v1/apps/{app_id}/permissions/auth-data';
                service.updateRedirectUris.__http_method = 'PUT';
                service.updateRedirectUris.__http_url = 'api/v1/apps/{app_id}/permissions/redirect-uri';
                service.upsertToAppPermissionsStore.__http_method = 'POST';
                service.upsertToAppPermissionsStore.__http_url = 'api/v1/apps/{app_id}/permissions/upsert-to-store';
                return service;
            };
        },
        Pricing: function () {
            return function (headers) {
                var service = {
                    getPricingModel: function (getPricingModelRequest) {
                        return httpClient.invoke('GET', 'api/v1/apps/{app_id}/pricing-model', getPricingModelRequest, headers);
                    },
                };
                service.getPricingModel.__http_method = 'GET';
                service.getPricingModel.__http_url = 'api/v1/apps/{app_id}/pricing-model';
                return service;
            };
        },
        ShareUrl: function () {
            return function (headers) {
                var service = {
                    allowedToInstall: function (allowedToInstallRequest) {
                        return httpClient.invoke('POST', 'api/v1/{app_id}/allowed-to-install', allowedToInstallRequest, headers);
                    },
                    createShareUrl: function (createShareUrlRequest) {
                        return httpClient.invoke('POST', 'api/v1/{app_id}/shareUrl', createShareUrlRequest, headers);
                    },
                    get: function (getShareUrlRequest) { return httpClient.invoke('GET', 'api/v2/{app_id}/shareUrl', getShareUrlRequest, headers); },
                    getShareUrl: function (getShareUrlRequest) { return httpClient.invoke('GET', 'api/v1/{app_id}/shareUrl', getShareUrlRequest, headers); },
                    revokeShareUrl: function (revokeShareUrlRequest) {
                        return httpClient.invoke('POST', 'api/v1/{app_id}/shareUrl/revoke', revokeShareUrlRequest, headers);
                    },
                };
                service.allowedToInstall.__http_method = 'POST';
                service.allowedToInstall.__http_url = 'api/v1/{app_id}/allowed-to-install';
                service.createShareUrl.__http_method = 'POST';
                service.createShareUrl.__http_url = 'api/v1/{app_id}/shareUrl';
                service.get.__http_method = 'GET';
                service.get.__http_url = 'api/v2/{app_id}/shareUrl';
                service.getShareUrl.__http_method = 'GET';
                service.getShareUrl.__http_url = 'api/v1/{app_id}/shareUrl';
                service.revokeShareUrl.__http_method = 'POST';
                service.revokeShareUrl.__http_url = 'api/v1/{app_id}/shareUrl/revoke';
                return service;
            };
        },
        Teams: function () {
            return function (headers) {
                var service = {
                    addTeamMember: function (addTeamMemberRequest) {
                        return httpClient.invoke('POST', 'api/v1/apps/{app_id}/teams', addTeamMemberRequest, headers);
                    },
                    changeAppOwner: function (changeAppOwnerRequest) {
                        return httpClient.invoke('PUT', 'api/v1/apps/{app_id}/change-app-owner/{user_id}', changeAppOwnerRequest, headers);
                    },
                    confirmTeamMember: function (confirmTeamMemberRequest) {
                        return httpClient.invoke('POST', 'api/v1/apps/{app_id}/teams/confirm', confirmTeamMemberRequest, headers);
                    },
                    deletePendingTeamMember: function (deletePendingTeamMemberRequest) {
                        return httpClient.invoke('DELETE', 'api/v1/apps/{app_id}/teams-pending/{email}', deletePendingTeamMemberRequest, headers);
                    },
                    deleteTeamMember: function (deleteTeamMemberRequest) {
                        return httpClient.invoke('DELETE', 'api/v1/apps/{app_id}/teams/{user_id}', deleteTeamMemberRequest, headers);
                    },
                    getTeamMembers: function (getTeamMembersRequest) {
                        return httpClient.invoke('GET', 'api/v1/apps/{app_id}/teams', getTeamMembersRequest, headers);
                    },
                    getUserRole: function (getUserRoleRequest) { return httpClient.invoke('GET', 'api/v1/apps/{app_id}/role', getUserRoleRequest, headers); },
                };
                service.addTeamMember.__http_method = 'POST';
                service.addTeamMember.__http_url = 'api/v1/apps/{app_id}/teams';
                service.changeAppOwner.__http_method = 'PUT';
                service.changeAppOwner.__http_url = 'api/v1/apps/{app_id}/change-app-owner/{user_id}';
                service.confirmTeamMember.__http_method = 'POST';
                service.confirmTeamMember.__http_url = 'api/v1/apps/{app_id}/teams/confirm';
                service.deletePendingTeamMember.__http_method = 'DELETE';
                service.deletePendingTeamMember.__http_url = 'api/v1/apps/{app_id}/teams-pending/{email}';
                service.deleteTeamMember.__http_method = 'DELETE';
                service.deleteTeamMember.__http_url = 'api/v1/apps/{app_id}/teams/{user_id}';
                service.getTeamMembers.__http_method = 'GET';
                service.getTeamMembers.__http_url = 'api/v1/apps/{app_id}/teams';
                service.getUserRole.__http_method = 'GET';
                service.getUserRole.__http_url = 'api/v1/apps/{app_id}/role';
                return service;
            };
        },
        Translations: function () {
            return function (headers) {
                var service = {
                    createTranslations: function (createTranslationsRequest) {
                        return httpClient.invoke('POST', 'api/v1/apps/translations', createTranslationsRequest, headers);
                    },
                    getSupportedLanguages: function (any) { return httpClient.invoke('GET', 'api/v1/apps/translations/languages', any, headers); },
                };
                service.createTranslations.__http_method = 'POST';
                service.createTranslations.__http_url = 'api/v1/apps/translations';
                service.getSupportedLanguages.__http_method = 'GET';
                service.getSupportedLanguages.__http_url = 'api/v1/apps/translations/languages';
                return service;
            };
        },
        Versions: function () {
            return function (headers) {
                var service = {
                    calculateVersionType: function (calculateVersionTypeRequest) {
                        return httpClient.invoke('GET', 'api/v1/calculate-version-type/{app_id}/{version}', calculateVersionTypeRequest, headers);
                    },
                    createVersion: function (createVersionRequest) {
                        return httpClient.invoke('POST', '/v1/apps/{app_id}/versions', createVersionRequest, headers);
                    },
                    getLatestDisplayVersions: function (getLatestDisplayVersionsRequest) {
                        return httpClient.invoke('GET', '/v1/apps/{app_id}/display-versions', getLatestDisplayVersionsRequest, headers);
                    },
                    getMarketVersions: function (getMarketVersionsRequest) {
                        return httpClient.invoke('POST', 'api/v2/market-versions/{ids_or_slugs}', getMarketVersionsRequest, headers);
                    },
                    getMarketVersionsByAppIdsOrSlugs: function (getMarketVersionsByAppIdsOrSlugsRequest) {
                        return httpClient.invoke('GET', '/v1/market-versions/{ids_or_slugs}', getMarketVersionsByAppIdsOrSlugsRequest, headers);
                    },
                    getVersionsByApp: function (getVersionsByAppRequest) {
                        return httpClient.invoke('GET', '/v1/apps/{app_id}/versions', getVersionsByAppRequest, headers);
                    },
                    getVersionsByStatus: function (getVersionsByStatusRequest) {
                        return httpClient.invoke('GET', '/v1/apps/versions/status', getVersionsByStatusRequest, headers);
                    },
                    patchPreviousVersion: function (patchPreviousVersionRequest) {
                        return httpClient.invoke('PATCH', '/v1/apps/{app_id}/versions', patchPreviousVersionRequest, headers);
                    },
                    updateVersion: function (updateVersionRequest) {
                        return httpClient.invoke('PUT', '/v1/apps/{app_id}/versions/update', updateVersionRequest, headers);
                    },
                };
                service.calculateVersionType.__http_method = 'GET';
                service.calculateVersionType.__http_url = 'api/v1/calculate-version-type/{app_id}/{version}';
                service.createVersion.__http_method = 'POST';
                service.createVersion.__http_url = '/v1/apps/{app_id}/versions';
                service.getLatestDisplayVersions.__http_method = 'GET';
                service.getLatestDisplayVersions.__http_url = '/v1/apps/{app_id}/display-versions';
                service.getMarketVersions.__http_method = 'POST';
                service.getMarketVersions.__http_url = 'api/v2/market-versions/{ids_or_slugs}';
                service.getMarketVersionsByAppIdsOrSlugs.__http_method = 'GET';
                service.getMarketVersionsByAppIdsOrSlugs.__http_url = '/v1/market-versions/{ids_or_slugs}';
                service.getVersionsByApp.__http_method = 'GET';
                service.getVersionsByApp.__http_url = '/v1/apps/{app_id}/versions';
                service.getVersionsByStatus.__http_method = 'GET';
                service.getVersionsByStatus.__http_url = '/v1/apps/versions/status';
                service.patchPreviousVersion.__http_method = 'PATCH';
                service.patchPreviousVersion.__http_url = '/v1/apps/{app_id}/versions';
                service.updateVersion.__http_method = 'PUT';
                service.updateVersion.__http_url = '/v1/apps/{app_id}/versions/update';
                return service;
            };
        },
        Webhooks: function () {
            return function (headers) {
                var service = {
                    delete: function (deleteWebhookRequest) {
                        return httpClient.invoke('DELETE', 'api/v1/webhooks/{app_id}/{webhook_slug}', deleteWebhookRequest, headers);
                    },
                    subscribe: function (webhookSubscribeRequest) {
                        return httpClient.invoke('POST', 'api/v1/webhooks/{app_id}', webhookSubscribeRequest, headers);
                    },
                    update: function (updateWebhookRequest) {
                        return httpClient.invoke('PUT', 'api/v1/webhooks/{app_id}/{webhook_slug}', updateWebhookRequest, headers);
                    },
                };
                service.delete.__http_method = 'DELETE';
                service.delete.__http_url = 'api/v1/webhooks/{app_id}/{webhook_slug}';
                service.subscribe.__http_method = 'POST';
                service.subscribe.__http_url = 'api/v1/webhooks/{app_id}';
                service.update.__http_method = 'PUT';
                service.update.__http_url = 'api/v1/webhooks/{app_id}/{webhook_slug}';
                return service;
            };
        },
    };
};
exports.AppServiceWebapp = AppServiceWebapp;
exports.AppServiceWebapp.__transport = 'http';
__exportStar(require("./types"), exports);
//# sourceMappingURL=http.js.map